/**
 * tp-type-tester.js
 * Auto-sizes editable text to fill the container width.
 * Clears the font name on first interaction so users can type fresh.
 * Supports font variant switching via label row buttons.
 */
(function () {
  var wraps = document.querySelectorAll('[id^="tp-tester-wrap-"]');

  wraps.forEach(function (wrap) {
    var input = wrap.querySelector('[id^="tp-tester-input-"]');
    if (!input) return;

    var section = wrap.closest('.tp-tester-section');
    var isFirstInteraction = true;
    var rafPending = false;
    var fitCallbacks = [];
    var fontLoadToken = 0;

    function quoteFontFamily(family) {
      return "'" + String(family).replace(/\\/g, '\\\\').replace(/'/g, "\\'") + "'";
    }

    function safeFrame(callback) {
      var done = false;
      function run() {
        if (done) return;
        done = true;
        callback();
      }
      if (window.requestAnimationFrame) {
        requestAnimationFrame(run);
      }
      window.setTimeout(run, 80);
    }

    function afterPaint() {
      return new Promise(function (resolve) {
        safeFrame(function () {
          safeFrame(resolve);
        });
      });
    }

    function setTesterVisible(isVisible) {
      input.style.setProperty('opacity', isVisible ? '1' : '0', 'important');
    }

    function waitForFontLoad(family, sample) {
      if (!document.fonts || !document.fonts.load) {
        return afterPaint();
      }

      var text = sample || input.textContent || input.getAttribute('data-placeholder') || 'Aa';
      var loadPromise;
      try {
        loadPromise = document.fonts.load('120px ' + quoteFontFamily(family), text);
      } catch (error) {
        return afterPaint();
      }
      var timeoutPromise = new Promise(function (resolve) {
        window.setTimeout(resolve, 1800);
      });

      return Promise.race([loadPromise, timeoutPromise]).catch(function () {
        return null;
      }).then(afterPaint);
    }

    function fitText(done) {
      if (typeof done === 'function') fitCallbacks.push(done);
      if (rafPending) return;
      rafPending = true;

      safeFrame(function () {
        rafPending = false;
        var callbacks;

        var wrapWidth = wrap.clientWidth;
        if (wrapWidth <= 0) {
          callbacks = fitCallbacks.splice(0);
          callbacks.forEach(function (callback) {
            callback();
          });
          return;
        }

        var text = input.textContent || input.getAttribute('data-placeholder') || 'Aa';
        if (text.trim() === '') text = input.getAttribute('data-placeholder') || 'Aa';

        var low = 12;
        var high = 800;
        var iterations = 20;

        input.style.display = 'inline-block';
        input.style.whiteSpace = 'nowrap';

        for (var i = 0; i < iterations; i++) {
          var mid = (low + high) / 2;
          input.style.fontSize = mid + 'px';

          if (input.scrollWidth <= wrapWidth) {
            low = mid;
          } else {
            high = mid;
          }
        }

        input.style.fontSize = (low * 0.98) + 'px';
        input.style.display = 'block';
        callbacks = fitCallbacks.splice(0);
        callbacks.forEach(function (callback) {
          callback();
        });
      });
    }

    function hideUntilReady(family, sample) {
      var token = ++fontLoadToken;
      var revealed = false;
      input.classList.remove('tp-ready');
      input.classList.add('waiting');
      setTesterVisible(false);

      function reveal() {
        if (revealed || token !== fontLoadToken) return;
        revealed = true;
        fitText(function () {
          if (token !== fontLoadToken) return;
          input.classList.remove('waiting');
          input.classList.add('tp-ready');
          setTesterVisible(true);
        });
      }

      var fallback = window.setTimeout(reveal, 2200);

      waitForFontLoad(family, sample).then(function () {
        window.clearTimeout(fallback);
        reveal();
      }).catch(function () {
        window.clearTimeout(fallback);
        reveal();
      });
    }

    /* Clear default text on first focus */
    input.addEventListener('focus', function () {
      input.classList.remove('waiting');
      input.classList.add('tp-typed');
      if (isFirstInteraction) {
        isFirstInteraction = false;
        input.textContent = '';
      }
    });

    /* Re-fit on every input */
    input.addEventListener('input', function () {
      fitText();
    });

    /* Re-fit on resize */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        fitText();
      });
      ro.observe(wrap);
    } else {
      window.addEventListener('resize', fitText);
    }

    /* Prevent Enter from creating line breaks */
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    });

    hideUntilReady(input.getAttribute('data-font-family') || 'TPTester', input.textContent);

    /* Font variant label row */
    if (section) {
      var variantRow = section.querySelector('[id^="tp-tester-variants-"]');
      if (variantRow) {
        var baseUrl = 'https://cdn.jsdelivr.net/gh/taylorpenton/font-hosting@main/';
        var buttons = variantRow.querySelectorAll('button');

        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var fontName = btn.getAttribute('data-font-name');
            var fontUrl = btn.getAttribute('data-font-url');
            var fontFormat = btn.getAttribute('data-font-format') || (fontUrl && fontUrl.indexOf('.woff2') !== -1 ? 'woff2' : 'woff');
            var familyId = 'TPTester-' + fontName.replace(/[^a-zA-Z0-9]/g, '');

            /* Load the font */
            var styleId = 'tp-font-face-' + familyId;
            if (!document.getElementById(styleId)) {
              var style = document.createElement('style');
              style.id = styleId;
              style.textContent = "@font-face { font-family: '" + familyId + "'; src: url('" + baseUrl + fontUrl + "') format('" + fontFormat + "'); font-style: normal; font-weight: 400; font-display: block; }";
              document.head.appendChild(style);
            }

            /* Apply to input */
            input.style.fontFamily = quoteFontFamily(familyId) + ', serif';
            input.setAttribute('data-placeholder', fontName);
            input.setAttribute('data-font-family', familyId);
            if (isFirstInteraction) {
              input.textContent = fontName;
            }

            /* Update active state */
            buttons.forEach(function (b) { b.classList.remove('active'); });
            btn.classList.add('active');

            hideUntilReady(familyId, input.textContent || fontName);
          });
        });
      }
    }
  });
})();
